import React from 'react';
import PropTypes from "prop-types";

export default class Spacer extends React.Component {
  render() {
    const {
      size,
    } = this.props;

    const difference = 10;

    const style = {
      height: difference
    };

    switch(size) {
      case 'sm':
        break;
      case 'md':
        style.height = difference * 2;
        break;
      case 'lg':
        style.height = difference * 3;
        break;
      case 'x-lg':
        style.height = difference * 4;
        break;
      case 'xx-lg':
        style.height = difference * 5;
        break;
      case 'xxx-lg':
        style.height = difference * 6;
        break;
    }

    return (
      <div
        style={style}
      />
    )
  }
};

Spacer.defaultProps = {
  size: 'sm'
};

Spacer.propTypes = {
  size: PropTypes.string,
};